import { useFileDownload } from 'hooks';
import { useCallback } from 'react';
import { Comment, Consultation } from 'types';

export const useViewComment = (): ((
  comment: Comment,
  consultation?: Consultation
) => void) => {
  const { openConsultationDocument } = useFileDownload();
  return useCallback(
    (comment: Comment, consultation?: Consultation) => {
      if (!consultation) return;
      comment.documents?.forEach(({ id, name, documentSource }) => {
        openConsultationDocument({
          documentId: id,
          consultationId: consultation.id,
          fileName: name,
          applicationReferenceNumber: consultation.reference,
          documentSource: documentSource,
        });
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
};
